// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","routeSearchTitle":"routeSearchTitle-3cV_5","createRouteLink":"createRouteLink-gNUPA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/search/_routeSearchTitle.css
// module id = 1273
// module chunks = 1